module.exports = __webpack_public_path__ + "img/step-2-img@2x.png";